import React from "react";
import { useRelatedTemplatesOnline } from "./useRelatedTemplateOnlineStatus";

const defaultCopy = {
  loading: "Checking related templates…",
  error: "Failed to check related templates.",
  empty: "No related template IDs.",
  allOk: "All related templates are online (state=401).",
  someBadTitle:
    "Some related templates are not online (expected state=401):",
};

const spineAvatarCopy = {
  loading: "正在检查关联 Spine 模版…",
  error: "检查关联 Spine 模版失败。",
  empty: "未配置关联 Spine 模版。",
  allOk: "关联 Spine 均已上线 (state=401)。",
  someBadTitle: "以下关联 Spine 模版未上线（需 state=401）：",
};

export type RelatedTemplatesOnlineCheckProps = {
  draft: any;
  /** Firestore 上存关联 id 的字段名 */
  idsKey?: "relatedTemplateIds" | "relatedSpineTemplateIds";
  /** 使用头像模版审核文案 */
  variant?: "spineDraft" | "avatarDraft";
};

export function RelatedTemplatesOnlineCheck({
  draft,
  idsKey = "relatedTemplateIds",
  variant = "spineDraft",
}: RelatedTemplatesOnlineCheckProps) {
  const { isLoading, items, hasIds, error } = useRelatedTemplatesOnline(
    draft,
    { idsKey },
  );
  const copy = variant === "avatarDraft" ? spineAvatarCopy : defaultCopy;

  if (isLoading) {
    return (
      <p className="text-sm text-muted-foreground">{copy.loading}</p>
    );
  }

  if (error) {
    return (
      <p className="text-sm text-destructive">{copy.error}</p>
    );
  }

  if (!hasIds) {
    return (
      <div className="rounded-md border border-border p-3 text-sm text-muted-foreground">
        {copy.empty}
      </div>
    );
  }

  const notOnline = items.filter((r: { isOnline: boolean }) => !r.isOnline);
  if (notOnline.length === 0) {
    return (
      <div className="rounded-md border border-green-600/50 bg-green-500/5 p-3 text-sm text-green-800 dark:text-green-300">
        {copy.allOk}
      </div>
    );
  }

  return (
    <div className="rounded-md border border-amber-600/50 bg-amber-500/5 p-3 text-sm text-amber-900 dark:text-amber-200">
      <p className="mb-2 font-medium">{copy.someBadTitle}</p>
      <ul className="list-inside list-disc space-y-1">
        {notOnline.map((r: { id: string; name?: string; state?: number }) => (
          <li key={r.id}>
            <code className="text-xs">{r.id}</code>
            {r.name ? ` (${r.name})` : ""} — state:{" "}
            {r.state != null ? r.state : "n/a"}
          </li>
        ))}
      </ul>
    </div>
  );
}
